import type { MediaRenderer } from './types';
import { videoRenderer } from './videoRenderer';
import { imageRenderer } from './imageRenderer';
import { urlRenderer } from './urlRenderer';

// Central registry of media renderers. Register a new content type here (and
// add its renderer file) to support it end-to-end - the player, scheduler,
// sync and DB layers are all type-agnostic.
const renderers = new Map<string, MediaRenderer>();

export function registerRenderer(renderer: MediaRenderer): void {
  renderers.set(renderer.type, renderer);
}

export function getRenderer(type: string): MediaRenderer | undefined {
  return renderers.get(type);
}

export function knownContentTypes(): string[] {
  return [...renderers.keys()];
}

// Default renderers.
registerRenderer(videoRenderer);
registerRenderer(imageRenderer);
registerRenderer(urlRenderer);
